// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__feXl+","hour":"Loader_hour__y1eyN","min":"Loader_min__t9HkZ","load9243":"Loader_load9243__o0TqH","circel":"Loader_circel__SK+y4"};